import React from 'react';
import './PolicyStyles.css'; // Import the external CSS file

const DataDeletionInstructions = () => {
  return (
    <div className="policy-container"> {/* Apply the main container class */}
      <h1>Data Deletion Instructions for Medhas AI</h1>

      <p>If you have used your Facebook account to log in or create an account with MedhasAI and wish to request the deletion of your associated data, please follow the instructions below.</p>

      <h2>How to Request Data Deletion:</h2>

      <p>To initiate a data deletion request for the information MedhasAI holds that is associated with your Facebook account, please follow these steps:</p>

      <ol>
        <li>
          <strong>Send an Email:</strong> Compose an email to our support team.
          <ul>
            <li><strong>To:</strong> <a href="mailto:contact@medhas.ai">[ contact@medhas.ai]</a></li>
            <li><strong>Subject:</strong> Data Deletion Request - Facebook Login</li>
            <li><strong>Body:</strong> In the email body, please clearly state your request to delete your data. Include the **email address** associated with your Facebook account that you used to log in to MedhasAI.</li>
          </ul>
        </li>
        <li>
          <strong>Confirmation and Processing:</strong> Once we receive your request, our team will verify your identity to ensure the security of your data. Upon successful verification, we will proceed with deleting your personal data from our systems.
        </li>
        <li>
          <strong>Timeline:</strong> We aim to complete all data deletion requests within [e.g., 30 business days] of successful verification. You will receive an email confirmation once your data has been deleted.
        </li>
      </ol>

      <h2>What Data Will Be Deleted?</h2>
      <p>Upon a verified deletion request, we will remove identifiable personal data that we have collected in connection with your use of MedhasAI via Facebook Login, such as your email address, name, and any other data directly associated with your MedhasAI account created through Facebook.</p>
      <p>Please note that some aggregated or anonymized data may be retained for analytical purposes, but this data will not be linked back to your identity.</p>

      <h2>Important Considerations:</h2>
      <ul>
        <li>Deleting your data from MedhasAI will not delete your Facebook account or any data held directly by Facebook. You must manage your Facebook account settings separately.</li>
        <li>If you have any questions or require assistance with the data deletion process, please do not hesitate to contact us at the email address provided above.</li>
      </ul>

      <p>Thank you for your understanding.</p>

      <p><strong>MedhasAI Team</strong></p>
      <p>Email: <a href="mailto:contact@medhas.ai">[contact@medhas.ai]</a></p>
      <div className="auth-back-button">
          <button onClick={() => window.location.href = 'https://medhas.ai/'} className="back-button">Back</button>
          {/* <button onClick={() => window.location.href = 'https://medhas.ai/signup'} className="signup-button">Join Now</button> */}
        </div>
    </div>
  );
};

export default DataDeletionInstructions;